import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.password');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-portal-gsdcadmin-password',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.password/view.scss */
/* src/app/portal.gsdcadmin.password/view.scss: no such file or directory */`],
})
export class PortalGsdcadminPasswordComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public info = {};
    public password = {};

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.load();
    }

    public async load() {
        const { data } = await wiz.call("session");
        this.info = data.user;

        await this.service.render();
    }

    public async changePassword() {
        let pdata = JSON.parse(JSON.stringify(this.password));

        if (pdata.data != pdata.repeat) return await this.service.alert.error("변경 비밀번호를 다시 확인해주세요");

        let pd = {};
        pd.current = this.service.auth.hash(pdata.current);
        pd.data = this.service.auth.hash(pdata.data);

        const { code, data } = await wiz.call("change_password", pd);

        if (code != 200) return await this.service.alert.error(data);

        await this.service.alert.success("변경되었습니다. 다시 로그인해주세요.");
        // location.href = "/auth/logout";
        sessionStorage.clear();
        window.location.href = '/auth/logout';
    }
}

export default PortalGsdcadminPasswordComponent;